const SortModel = {};

SortModel.TYPE_POPULARITY = 0;
SortModel.TYPE_PRICE_US = 1;
SortModel.TYPE_PRICE_EU = 2;

SortModel.OPTION_POPULAR_LAST = 0;
SortModel.OPTION_POPULAR_FIRST = 1;
SortModel.OPTION_PRICE_UP = 2;
SortModel.OPTION_PRICE_DOWN = 3;
SortModel.OPTION_NEWEST = 4;
SortModel.OPTION_OLDEST = 5;

export default SortModel;
